import React, { useState } from "react";
import emailjs from "@emailjs/browser";

function OurPartnerArea() {

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();

      // 🔴 Validation
    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setError("");
    setLoading(true);
    setSuccess(false);

    emailjs.send(
      "service_s9ojob8",    
      "template_tqulehn",    // 🔴 replace
      {
        user_email: email,
      },
      "VzkKwdWM6vTHc9IF-"      // 🔴 replace
    )
    .then(() => {
      setSuccess(true);
      setEmail("");
      setLoading(false);
    })
    .catch((error) => {
      console.error(error);
      setLoading(false);
    });
  };

  return (
    <section className="our-partner">
      <div className="container-fluid g-0 overflow-hidden">
        <div className="row align-items-center g-0">
          <div className="col-12">
            <div className="newsletter">
              <div className="subscribes">

                <span>Stay Updated</span>
                <h1>Get Insights & Updates</h1>
                <h2>From Gybits</h2>
                <p>
                  Join our newsletter to receive updates on AI, software, and new projects.
                </p>

                <div className="subscribe-form">
                  <form onSubmit={handleNewsletterSubmit}>

                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => {
                                          setEmail(e.target.value);
                                          setError(""); // clears error while typing
                                        }}
                      required
                    />
                    <input type="submit" defaultValue="Connect" />
                   {error && (
                                <p style={{ color: "red", marginTop: "5px" }}>
                                  {error}
                                </p>
                              )}
                  </form>
                </div>

                {success && (
                  <p style={{ color: "green", marginTop: "10px" }}>
                    Thanks for subscribing!
                  </p>
                )}

                <p style={{ fontSize: "12px", marginTop: "10px" }}>
                  No spam. Only valuable insights.
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurPartnerArea;